import type { PremiereProject } from '../premiere/interfaces';
import { requestDialog } from './requestDialog';
import type { SavePremiereProjectDialogRequest } from './savePremiereProjectDialogRequest';

export function showSavePremiereProjectDialog(
  project: PremiereProject,
  targetFolderId: string | undefined,
) {
  const req: SavePremiereProjectDialogRequest = {
    project,
    targetFolderId,
  };
  requestDialog(req, () => import('@mimir/web/components/Common/Dialogs/dialogs/SavePremiereProjectDialog.vue'));
}
